import React from 'react';
import ReactExport from 'react-data-export';
import { Button } from '@material-ui/core';
import jMoment from 'moment-jalaali';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

interface Props {
    data: any[];
    label?: string;
}

const ExcelExport = ({ data, label }: Props) => {

    const flattData = (data: any) => {
        const newData = data.map((item: any) => {
            return {
                id: item.id,
                customerAddress: item.customerAddress,
                centerName: item.centerName,
                partnerName: item.partnerName,
                deliveryDate:
                    item.deliveryDate &&
                    jMoment(item.deliveryDate, 'YYYY/M/D')
                        .locale('fa')
                        .format('jYY/jMM/jDD'),
                customerMobileNumber: item.customerMobileNumber + '',
                packages: undefined,
                childOrders: undefined
            };
        });
        return newData;
    };

    if (data.length > 0) {
        return (
            <ExcelFile
                element={
                    <Button
                        style={{ marginLeft: '5px' }}
                        variant="outlined"
                        color="primary"
                    >
                        {label ? label : "دانلود فایل EXCEL"}
                    </Button>
                }
            >
                <ExcelSheet data={data} name="orders">
                    {data &&
                        Object.entries(data[0])?.map(el => {
                            return <ExcelColumn label={el[0]} value={el[0]} />;
                        })}
                </ExcelSheet>
            </ExcelFile>
        );
    } else {
        return (
            <Button
                style={{ marginLeft: '5px' }}
                variant="outlined"
                color="primary"
            >
                فایل مشکل دارد
            </Button>
        )
    }
};

export default ExcelExport;
